/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import { View } from 'backbone.marionette';
import _ from 'lodash';
import Backbone from 'backbone';

import PhoneFormatBehavior from '@/behaviors/PhoneFormatBehavior';
import TooltipView from '@/views/TooltipView';

import tmplProfileInfoForm from './ProfileFormView.hbs';

const ProfileFormView = View.extend({
  template: tmplProfileInfoForm,

  className: 'profile-info-form',

  ui: {
    profileForm: '.profile-form',
    phoneFormat: '.phone-format',
    resetPassword: '.reset-password',
    hidePassword: '.hide-password',
    passwordFields: '.password-fields',
    tooltip: '.tooltip-container'
  },

  regions: {
    tooltip: '@ui.tooltip'
  },

  events: {
    'click @ui.resetPassword': 'showPasswordFields',
    'click @ui.hidePassword': 'hidePasswordFields'
  },

  behaviors: {
    telephone: PhoneFormatBehavior
  },

  triggers: {
    'click @ui.resetPassword': 'passwordFields:shown',
    'click @ui.hidePassword': 'passwordFields:hidden'
  },

  onRender() {
    this.passwordFieldsShown = false;
    this.ui.passwordFields.hide();
    this.ui.hidePassword.hide();

    this.showChildView(
      'tooltip',
      new TooltipView({
        model: new Backbone.Model({
          tooltipText:
            'Your password must be at least 12 characters long and contain at least 1 lowercase letter, 1 uppercase letter, 1 number, and 1 special character.',
          placement: 'top'
        })
      })
    );
  },

  toggleForm(state) {
    this.$el.find(':input').prop('disabled', !state);
  },

  showPasswordFields(e) {
    e.preventDefault();

    this.passwordFieldsShown = true;
    this.ui.passwordFields.show();
    this.ui.hidePassword.show();
    this.ui.resetPassword.hide();
  },

  hidePasswordFields(e) {
    e.preventDefault();

    _.each(this.ui.passwordFields.find('input'), (passwordField) => {
      $(passwordField).val(''); //reset password fields before hiding.
    });

    this.passwordFieldsShown = false;
    this.ui.passwordFields.hide();
    this.ui.hidePassword.hide();
    this.ui.resetPassword.show();
  }
});

export default ProfileFormView;
